var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGiftConfirmationImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 170,
    viewBox: "0 0 375 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 170,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M202.395 86.3603L189.838 92.3157C188.389 93.0029 186.609 92.3681 185.922 90.9192L179.966 78.3618C179.279 76.9129 179.914 75.1328 181.363 74.4456L193.92 68.4902C195.369 67.803 197.149 68.4378 197.836 69.8868L203.792 82.4441C204.479 83.8931 203.844 85.6731 202.395 86.3603Z",
    fill: "#FDC812"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M168.812 96C176.822 96 183.312 89.5095 183.312 81.5C183.312 73.4905 176.822 67 168.812 67C160.802 67 154.312 73.4905 154.312 81.5C154.312 89.5095 160.802 96 168.812 96Z",
    fill: "#FDA4B1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M162.754 87.246C149.81 86.8348 146.553 88.6972 139.754 99.754C140.165 86.8099 138.303 83.5523 127.246 76.754C140.19 77.1652 143.448 75.3028 150.246 64.246C149.943 77.2221 151.774 80.5879 162.754 87.246Z",
    fill: "#BFD14A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M203.489 84.3201H126.851V146H203.489V84.3201Z",
    fill: "#C5E2F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M243.583 84.3201H203.474V146H243.583V84.3201Z",
    fill: "#7EC0E3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M206.358 60.7837L127.567 44.3159L124.988 56.6474L203.779 73.1152L206.358 60.7837Z",
    fill: "#C5E2F2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M249.999 69.9023L206.24 60.7563L203.66 73.0878L247.42 82.2338L249.999 69.9023Z",
    fill: "#7EC0E3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M203.505 84.3201H126.944V86.6639H203.505V84.3201Z",
    fill: "#3294C5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M243.583 84.3201H203.474V86.6639H243.583V84.3201Z",
    fill: "#3294C5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M166.528 84.3201H163.998V146H166.528V84.3201Z",
    fill: "#7EC0E3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M170.057 53.1948L167.581 52.6772L165.002 65.0087L167.478 65.5263L170.057 53.1948Z",
    fill: "#7EC0E3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M224.947 84.3201H222.417V146H224.947V84.3201Z",
    fill: "#3294C5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M227.242 65.1497L224.766 64.6321L222.186 76.9635L224.663 77.4811L227.242 65.1497Z",
    fill: "#3294C5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M170.628 37.3061C170.104 36.5814 169.564 35.872 168.885 35.2707C167.728 34.2221 166.293 33.5128 164.766 33.189C159.938 32.1867 155.202 35.2707 154.199 40.0971C153.196 44.9236 156.081 49.3645 160.647 50.5673L183.741 55.3937C182.969 54.3298 182.198 53.2658 181.427 52.2018L176.49 45.417L171.939 39.1719C171.492 38.5551 171.075 37.9229 170.644 37.3061H170.628Z",
    stroke: "#3294C5",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M203.024 44.1216C203.024 44.1216 203.101 44.0753 203.131 44.0599C204.088 43.5048 205.06 42.9651 206.14 42.7029C207.405 42.3945 208.747 42.3791 210.012 42.6567C214.84 43.659 217.941 48.3929 216.923 53.2194C215.951 57.8916 211.477 60.9602 206.818 60.2355L183.725 55.409L185.484 54.3759L189.757 51.8778L195.048 48.7784L199.877 45.9566C200.926 45.3398 201.975 44.723 203.024 44.1062V44.1216Z",
    stroke: "#3294C5",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0542 66.4326C58.8704 66.9176 57.5938 67.7506 55.3917 72.5532C54.9067 67.3695 54.0738 66.0929 49.2711 63.8908C54.4548 63.4058 55.7315 62.5729 57.9335 57.7702C58.405 63.0326 59.2515 64.2306 64.0542 66.4326Z",
    fill: "#FDA4B1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5415 38.4919C83.4469 38.8195 85.2564 37.5409 85.584 35.6356C85.9116 33.7302 84.6331 31.9207 82.7277 31.5931C80.8223 31.2655 79.0128 32.544 78.6852 34.4494C78.3576 36.3548 79.6362 38.1642 81.5415 38.4919Z",
    fill: "#3E91FF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M91.371 93.2532L84.2528 98.2827C83.4315 98.863 82.2635 98.6622 81.6831 97.8408L76.6537 90.7227C76.0733 89.9013 76.2742 88.7333 77.0955 88.153L84.2137 83.1235C85.035 82.5431 86.203 82.744 86.7834 83.5653L91.8129 90.6835C92.3932 91.5048 92.1924 92.6728 91.371 93.2532Z",
    fill: "#FDC812"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M115.967 41.8743C112.154 42.2552 111.247 42.8964 109.614 46.3628C109.233 42.5502 108.592 41.6427 105.126 40.0103C108.938 39.6294 109.846 38.9882 111.478 35.5218C111.782 39.3211 112.423 40.2286 115.967 41.8743Z",
    fill: "#FDC812"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.934 75.1069C95.4151 57.6345 74.5907 47.1596 53.6593 47.9257C52.9148 47.9529 52.2936 47.3602 52.2718 46.6017C52.2501 45.8432 52.8359 45.2063 53.5804 45.179C75.4272 44.3795 97.0879 55.2933 110.116 73.4766C110.554 74.0876 110.42 74.9479 109.817 75.3981C109.215 75.8483 108.371 75.7179 107.934 75.1069Z",
    fill: "#986FE3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftConfirmationImage);
export default __webpack_public_path__ + "static/media/gift-confirmation-image.d9f4d2c1958b0710a881b645133e76e9.svg";
export { ForwardRef as ReactComponent };